// extracted by mini-css-extract-plugin
module.exports = {"backdropBlur":"StatsButton_backdropBlur__2T3Kz","ChartTable":"StatsButton_ChartTable__2k1Av"};